/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const CustomDomainPage = lazyLoad(
  () => import('./index'),
  module => module.CustomDomainPage
);
